/* eslint-disable */
"use strict";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_email || process.env.VUE_APP_service_documenti;
})();

async function inviaEmail(destinatario, copiaCarbone, infoEmail, allegati) {
  const msg = {
    to: destinatario,
    cc: copiaCarbone,
    from: infoEmail.mittente,
    subject: infoEmail.oggetto,
    text: infoEmail.messaggio,
    html: infoEmail.messaggioHtml,
  };

  const data = {
    messaggio: msg,
    allegati,
  };
  try {
    const response = await fetch(
      `${service}/${infoEmail.templateId ? "/" + infoEmail.templateId : ""}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

export default {
  inviaEmail,
};
